<div [ngClass]="containerClass" (click)="animate()" #svg id="svg"></div>
